var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAction',[_c('ErrorButton',{attrs:{"shrink":"","light":""},nativeOn:{"click":function($event){return _vm.openDeleteAgencyFromTierDialog.apply(null, arguments)}}},[_vm._v("Remove")]),_c('DeleteAgencyFromTierDialog',{attrs:{"isOpen":_vm.isDialogOpen,"agency":_vm.agency,"tierId":_vm.tierId},on:{"close":_vm.closeDeleteAgencyFromTierDialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }